(function () {
  var MOBILE_BREAKPOINT = 768;

  function isMobileCarousel() {
    return window.matchMedia('(max-width: ' + (MOBILE_BREAKPOINT - 1) + 'px)').matches;
  }

  function getScrollAmount(track) {
    var card = track.querySelector('.glow-challenge__card');
    if (!card) return 348;
    var gap = parseFloat(getComputedStyle(track).gap) || 8;
    return card.offsetWidth + gap;
  }

  function getActiveIndex(track) {
    var amount = getScrollAmount(track);
    if (amount <= 0) return 0;
    return Math.round(track.scrollLeft / amount);
  }

  function updateDots(track, dots) {
    if (!dots.length) return;

    var activeIndex = getActiveIndex(track);
    var maxIndex = track.querySelectorAll('.glow-challenge__card').length - 1;
    activeIndex = Math.max(0, Math.min(activeIndex, maxIndex));

    dots.forEach(function (dot, index) {
      var isActive = index === activeIndex;
      dot.classList.toggle('glow-challenge__dot--active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function scrollToIndex(track, index) {
    track.scrollTo({
      left: getScrollAmount(track) * index,
      behavior: 'smooth'
    });
  }

  function initGlowChallenge(section) {
    var carousel = section.querySelector('[data-glow-challenge-carousel]');
    if (!carousel) return;

    var track = carousel.querySelector('[data-glow-challenge-track]');
    var dotsWrap = carousel.querySelector('[data-glow-challenge-dots]');
    if (!track) return;

    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-glow-challenge-dot]')) : [];

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        if (!isMobileCarousel()) return;
        scrollToIndex(track, index);
      });
    });

    track.addEventListener('scroll', function () {
      if (!isMobileCarousel()) return;
      updateDots(track, dots);
    });

    window.addEventListener('resize', function () {
      if (isMobileCarousel()) {
        updateDots(track, dots);
      } else {
        track.scrollLeft = 0;
        dots.forEach(function (dot) {
          dot.classList.remove('glow-challenge__dot--active');
          dot.setAttribute('aria-current', 'false');
        });
        if (dots[0]) {
          dots[0].classList.add('glow-challenge__dot--active');
          dots[0].setAttribute('aria-current', 'true');
        }
      }
    });

    if (isMobileCarousel()) {
      updateDots(track, dots);
    }
  }

  function initAll() {
    document.querySelectorAll('.glow-challenge').forEach(initGlowChallenge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.glow-challenge');
    if (section) initGlowChallenge(section);
  });
})();
